import { LinearGradient, LinearGradientBase } from "./LinearGradient"
import { RadialGradient, RadialGradientBase } from "./RadialGradient"

/**
 * @public
 */
type Gradient = LinearGradient | RadialGradient

export { Gradient, LinearGradient, LinearGradientBase, RadialGradient, RadialGradientBase }
